import React, {Component} from 'react';
import TopMenu from "../components/TopMenu";
import LogicList from "../components/LogicList";
import SecondaryMenu from "../components/SecondaryMenu";
import axios from "axios";
import {Helmet} from "react-helmet";
import axiosConfig from "../utils/axiosConfig";
import messageCodes from "../utils/messageCodes";
import {connect} from "react-redux";
import {showToastForBackend, showToastForFrontend} from "../actions/toastActions";
import getAxiosConfig from "../utils/axiosConfig";
import {Navigate, useNavigate, useParams} from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ImportPanel from "../components/SecondaryMenu/ImportPanel";
import ExportPanel from "../components/SecondaryMenu/ExportPanel";
import AddLogicInput from "../components/LogicList/AddLogicInput";
import onGoLiveRequest from "../common/onGoLiveRequest";

class Logics extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showImportPanel: false,
            showExportPanel: false,
            logics: [],
            logicIds: [],
            selected: [],
            searchValue: "",
            isAddLogicInputVisible : false
        };

        this.onLogicSelectedChange = this.onLogicSelectedChange.bind(this);
        this.onImportClick = this.onImportClick.bind(this);
        this.toggleImportPanel = this.toggleImportPanel.bind(this);
        this.toggleExportPanel = this.toggleExportPanel.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onPauseLive = this.onPauseLive.bind(this);
        this.getLogicList = this.getLogicList.bind(this);
        this.onSearchValueChange = this.onSearchValueChange.bind(this);
        this.onClone = this.onClone.bind(this);
        this.onImportFromEngineSuccessful = this.onImportFromEngineSuccessful.bind(this);
        this.onImportFromDashSuccessful = this.onImportFromDashSuccessful.bind(this);
    }


    componentDidMount() {
        this.getLogicList();
    }

    onImportClick() {
        this.setState(() => ({
            showImportPanel: true
        }));
    }

    onExportClick() {
        this.setState(() => ({
            showExportPanel: true
        }));
    }

    getLogicList() {
        axios.get(this.props.properties.logicUrl, axiosConfig())
            .then((response) => {
                this.setState({
                    logics:response.data.sort((a, b) => {
                        return new Date(b.createdDate) - new Date(a.createdDate);
                    }),
                    selected: response.data.map((p) => ({type : p.type, isSelected : false})),
                });
            })
            .catch((err) => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                } else {
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            });
    }

    onLogicSelectedChange(index) {
        this.setState((prevState) => {
            let newSelected = prevState.selected;
            newSelected[index].isSelected = !newSelected[index].isSelected;
            let selectedLogicIds = []
            prevState.selected.forEach((selectedValue, index) => {
                if (selectedValue.isSelected) {
                    selectedLogicIds.push(this.state.logics[index].id);
                }
            });
            return {
                selected: newSelected,
                logicsId: selectedLogicIds
            };
        });
    }

    toggleImportPanel() {
        this.setState((prevState) => ({
            showImportPanel: !prevState.showImportPanel
        }));
    }

    toggleExportPanel() {
        this.setState((prevState) => ({
            showExportPanel: !prevState.showExportPanel
        }));
    }

    onDeleteClick() {
        let toBeDeletedLogics = [];
        this.state.selected.forEach((selectedValue, index) => {
            if (
                this.state.logics[index].name.toLowerCase().includes(this.state.searchValue.toLowerCase())
                && selectedValue.isSelected
            ) {
                toBeDeletedLogics.push(this.state.logics[index].id);
            }
        });
        axios.delete(this.props.properties.logicUrl + "/delete", {...axiosConfig(), data: toBeDeletedLogics})
            .then(() => {
                this.props.showToastForFrontend(messageCodes.LOGIC_SAVED);
                this.getLogicList();
            })
            .catch((err) => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    onGoLive() {
        let toGoLiveLogics = [];
        this.state.selected.forEach((selectedValue, index) => {
            if (selectedValue.isSelected) {
                toGoLiveLogics.push(this.state.logics[index].id);
            }
        });

        onGoLiveRequest(
            this.props.properties.logicUrl,
            this.props.showToastForFrontend,
            this.props.showToastForBackend,
            toGoLiveLogics,
            this.getLogicList
        );
    }

    pauseLiveConfirmAlert() {
        confirmAlert({
            title: 'Pause logic',
            message: 'Are you sure to pause logic?',
            customUI: ({onClose}) => {
                return (
                    <div className="confirm-dialog">
                        <div className="dialog-box">
                            <div className="title">
                                <span>Are you sure you want to pause the logic?</span>
                            </div>
                            <div className="input-area">
                                <button onClick={() => {
                                    this.onPauseLive();
                                    onClose();
                                }}>Pause</button>
                                <button className={"cancel-button"} onClick={onClose}>Cancel</button>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }

    onPauseLive() {
        let toPauseLiveLogics = [];
        this.state.selected.forEach((selectedValue, index) => {
            if (selectedValue.isSelected) {
                toPauseLiveLogics.push(this.state.logics[index].id);
            }
        });

        axios.post(this.props.properties.logicUrl + "/pauseLive", toPauseLiveLogics, axiosConfig())
            .then(() => {
                this.props.showToastForFrontend(messageCodes.PAUSE_SUCCESS);
                this.getLogicList();
            })
            .catch((err) => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    onSearchValueChange(e) {
        this.setState({
            searchValue: e.target.value
        });
    }

    onImportFromEngineSuccessful(response) {
        let uploadedData = response.uploadedData;
        if (uploadedData.type === 'MASTER') {
            this.setState((prevState) => {
                let logics = prevState.logics;
                let selected = prevState.selected;
                if (response.newLogicCreated) {
                    logics.unshift(response.uploadedData);
                    selected.unshift(false);
                } else {
                    let indexOfElementToUpdate = logics.findIndex(logic => logic.id === uploadedData.id);
                    if (indexOfElementToUpdate !== -1) {
                        logics = [
                            ...logics.slice(0, indexOfElementToUpdate),
                            uploadedData,
                            ...logics.slice(indexOfElementToUpdate + 1)
                        ];
                    }
                }
                return {
                    logics: logics,
                    selected: selected
                }
            })

        }
    }
    onImportFromDashSuccessful() {
        this.getLogicList();
    }
    updateAddLogicInputVisibility(){
        let LogicInputVisible = !this.state.isAddLogicInputVisible;
        this.setState({
            isAddLogicInputVisible : LogicInputVisible
        })
    }
    onClone() {
        let logicsToClone = [];
        this.state.selected.forEach((selectedValue, index) => {
            if (selectedValue.isSelected) {
                logicsToClone.push(this.state.logics[index]);
            }
        });

        if (logicsToClone.length !== 1) {
            this.props.showToastForBackend(messageCodes.CUSTOM_TOAST("Clone error","Can only clone 1 logic a time", 'error'));

            return;
        }

        axios.post(this.props.properties.logicUrl + "/clone",
            {
                "logicName": logicsToClone[0].name + "_clone",
                "baseLogicId": logicsToClone[0].id,
                "logicType": logicsToClone[0].type,
                "userEmail": localStorage.getItem("user")
            },
            getAxiosConfig()).then((result) => {
            if (result) {
                this.setState({logicName: ''});
                this.props.history(`/logics/${result.data.logic.id}/versions/${result.data.version}`);
            }
        }).catch((err) => {
            if (err.response) {
                this.props.showToastForBackend(err.response.data);
            }
        });
    }
    hasNotAccess() {
        return this.props.privileges['Logics'] === "no access";
    }
    isReadOnly() {
        return this.props.privileges['Logics'] === "read-only";
    }

    render() {
        if (this.hasNotAccess()) {
            return <Navigate to="/"/>;
        }

        return (
            <div className="logics-page">
                <Helmet>
                    <title>Logics</title>
                </Helmet>
                <TopMenu/>
                <SecondaryMenu anySelected={this.state.selected.find(value => value.isSelected === true && value.type === "COMPONENT") || this.state.selected.find(value => value.isSelected === true)}
                               onImportClick={() => this.onImportClick()}
                               onExportClick={() => this.onExportClick()}
                               onDeleteClick={() => this.onDeleteClick()}
                               onGoLive={() => this.onGoLive()}
                               onClone={() => this.onClone()}
                               onPauseLive={() => this.pauseLiveConfirmAlert()}
                               searchValue={this.state.searchValue}
                               onSearchValueChange={this.onSearchValueChange}
                               isReadOnly={this.isReadOnly()}
                               updateAddLogicInputVisibility={()=>this.updateAddLogicInputVisibility()}
                />
                <div className="main-input-screen">
                    {this.state.isAddLogicInputVisible && <AddLogicInput onClickClose={()=>this.updateAddLogicInputVisibility()}/>}
                    <LogicList
                        logics={this.state.logics}
                        searchValue={this.state.searchValue.toLowerCase()}
                        selected={this.state.selected}
                        onLogicSelectedChange={(index) => this.onLogicSelectedChange(index)}
                        logicUrl={this.props.properties.logicUrl}
                        showToastForBackend={showToastForBackend}
                        showToastForFrontend={showToastForFrontend}
                    />
                    {this.state.showImportPanel && (
                        <ImportPanel toggleImportPanel={this.toggleImportPanel}
                                     onImportFromEngineSuccessful={this.onImportFromEngineSuccessful}
                                     onImportFromDashSuccessful={this.onImportFromDashSuccessful}/>
                    )}
                    {this.state.showExportPanel && (
                        <ExportPanel logicIds={this.state.logicsId}
                                     toggleExportPanel={this.toggleExportPanel}/>
                    )}
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        properties: state.properties
    }
}

//eslint-disable-next-line react/display-name
const withRouter = Logics => props => {
    const params = useParams();
    const history = useNavigate();
    return (
      <Logics {...props} {...{params, history}}/>
    );
  };

export default withRouter(connect(mapStateToProps, {showToastForBackend, showToastForFrontend})(Logics));
